export default function PermCommonData(){
    return{
        name: 'Permanent Life Insurance',
        subtitle: '',
        hyperlinks: [
            {
              title: 'Indexed Universal Life Insurance',
              link: '#indexeduniversallifeinsurance'
            },
            {
              title: 'Variable Universal Life Insurance',
              link: '#variableuniversallifeinsurance',
            },
            {
              title: 'Universal Life Insurance',
              link: '#universallifeinsurance',
            },
            {
              title: 'Whole Life Insurance',
              link: '#wholelifeinsurance',
            }
          ],
        }}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/perm/index.js